export default __webpack_public_path__ + "static/media/ic_south_sudan.9826969f.svg";